import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const ReportList = lazy(() => import('@components/Report/ReportList'));

/** 홈 > 기업보고자료 관리 */
const Report = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <ReportList />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default Report;
